"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_STORE_LOCATIONS_LIST = void 0;

var _client = require("@apollo/client");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query {\n    storeLocationList(active: true) {\n      active\n      name\n      phone\n      storeId\n      location {\n        postalCode\n        state\n        city\n        country\n        countryCode\n        latitude\n        longitude\n        address1\n        address2\n        building\n      }\n      hours {\n        regular {\n          close\n          day\n          open\n        }\n        override {\n          date\n          end\n          name\n          start\n          timeType\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GET_STORE_LOCATIONS_LIST = (0, _client.gql)(_templateObject());
exports.GET_STORE_LOCATIONS_LIST = GET_STORE_LOCATIONS_LIST;